import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { CloseByEmptySpaceType } from 'app/types/close-by-empty-space';

export function withCloseByEmptySpace<P>(
  WrappedComponent: React.ComponentType<P & CloseByEmptySpaceType>,
) {
  const NewComponent = (props: P) => {
    const [isOpenDropdown, setIsOpenDropdown] = useState<boolean>(false);

    const dropdownRef = useRef(null);
    const selectRef = useRef(null);

    const handleDropdown = useCallback((e: MouseEvent) => {
      if (e.target === selectRef.current) {
        setIsOpenDropdown(true);
      }

      if (isOpenDropdown && e.target !== dropdownRef.current) {
        setIsOpenDropdown(false);
      }
    }, [isOpenDropdown]);

    useEffect(() => {
      const body = document.querySelector('body');

      body?.addEventListener('click', handleDropdown);

      return () => body?.removeEventListener('click', handleDropdown);
    }, [handleDropdown]);

    const handleSwitchDropdown = () => {
      setIsOpenDropdown(!isOpenDropdown);
    };

    return (
      <WrappedComponent
        dropdownRef={dropdownRef}
        selectRef={selectRef}
        active={isOpenDropdown}
        setActive={setIsOpenDropdown}
        handleSwitchDropdown={handleSwitchDropdown}
        {...props}
      />
    );
  };

  return NewComponent;
}
